import { createDomain } from 'effector';

import api from 'api';

const domain = createDomain('api/guide');

const GuideFxs = {
    getFirstAvailableArticleFx: domain.effect(api.guide.getFirstAvailableArticle),
};

export default GuideFxs;
